import React, { useEffect, useState } from "react";

const EmailNotification = ({ email, onEmailChange, emailisvalid }) => {
    const [localEmail, setLocalEmail] = useState(email || "");
    const [emailError, setEmailError] = useState("");
    

    useEffect(() => {
        setLocalEmail(email || "");
    }, [email]);

    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const handleEmailChange = (e) => {
        const newEmail = e.target.value;
        setLocalEmail(newEmail);
        
        if (!newEmail) {
            setEmailError("Email is required");
        } else if (!validateEmail(newEmail)) {
            setEmailError("Please enter a valid email address");
        } else {
            setEmailError("");
            onEmailChange?.(newEmail);
        }
    };

    const handleVerifyEmail = () => {
        console.log("Verify email");
    };

    return (
        <div className="dc-tabscontent tab-content">
            <div className="dc-emailnotiholder tab-pane active fade show" id="dc-emailnoti">
                <div className="dc-emailnoti">
                    <div className="dc-tabscontenttitle">
                        <h3>Manage Email Notifications</h3>
                    </div>
                    <div className="dc-settingscontent dc-sidepadding">
                        <div className="dc-description">
                            <p>All the emails will be sent to the below email address</p>
                        </div>
                        <div className="dc-formtheme dc-userform">
                            <fieldset >
                                <div className="form-group">
                                    <input 
                                        type="text" 
                                        name="useremail" 
                                        className={`form-control ${emailError ? 'is-invalid' : ''}`}
                                        placeholder="Enter your email"
                                        value={localEmail}
                                        onChange={handleEmailChange}
                                    />
                                    {emailError && (
                                        <div className="invalid-feedback">
                                            {emailError}
                                        </div>
                                    )}
                                </div>
                                {emailisvalid === "0" && emailisvalid === "" && emailisvalid === null && emailisvalid === undefined && emailisvalid === false ? (
                                    <div className="invalid-feedback">
                                        <a href="#" onClick={handleVerifyEmail}>Verify your email</a>
                                    </div>
                                ) : (
                                    <div className="invalid-feedback">
                                        Email is verified
                                    </div>
                                )}
                            </fieldset>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EmailNotification;
